import { MultiCountryData } from '../shared/models/multi-country-data';

export const environment = {
    isForzaCourierPack: true,
    lastLanguage: 'es',
    currentLanguage: 'es',
    production: true,
    version: '2.1.6.0-20240822-qa',
    captchaKey: '6Lfm628qAAAAAKjmRZV0XfXMwyIh5Lh7txzq6qId',
    turnstileKey: '0x4AAAAAACE0DaSwyLbjN6GJ',
    mapboxKey:
        'pk.eyJ1IjoibHVpczc1MjAwIiwiYSI6ImNtaXMzM2cwNTE2MzMzZXB3d2o4cW15OHUifQ.UNv14xS6SaCUVYG2kphn4w',
    test: 'qa',
    googleAnalytics: 'G-L2G7FL9MP3',
    googleAnalyticsTechnical: 'G-JX2GHBQLYG',
    rol: '',
    expressUserData: [],
    multiCountryData: [] as MultiCountryData[],
    basePath: '/',
    apigoogle: 'AIzaSyBLMW-yZQI4A_mnrDCugdzhMl1RPLjrJ4w',
    linkEntregaPage: 'https://linkdepago.forzadelivery.com',
    apiLinkEntrega: 'https://backendlinkpago.forzadelivery.com/api/V1',
    apiBackApp: 'https://backendlinkpago.forzadelivery.com/app/api/V1',
    linkQrAfiliatePage: 'https://qa.portal.forzadelivery.com/clubForza/',
    storeLink: 'https://qa.tienda.forzadelivery.com',
    routes: [
        {
            path: '',
            loadComponent: () =>
                import(
                    '../pages/service-tracking-v2/service-tracking-v2.component'
                ).then((m) => m.ServiceTrackingV2Component),
        },
        {
            path: ':guia',
            loadComponent: () =>
                import(
                    '../pages/service-tracking-v2/service-tracking-v2.component'
                ).then((m) => m.ServiceTrackingV2Component),
        },
        {
            path: ':guia/:val',
            loadComponent: () =>
                import(
                    '../pages/service-tracking-v2/service-tracking-v2.component'
                ).then((m) => m.ServiceTrackingV2Component),
        },
        {
            path: 'pagina-no-encontrada',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
        {
            path: '**',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
    ],
};

export enum Constants {
    api = 'https://qa.rastreo.forzadelivery.com/fd/Home.aspx/API',
    api2 = 'https://qa.rastreo.forzadelivery.com/fd/Home.aspx/API',
    apiHN = 'https://qa.rastreo.forzadelivery.com/fdHN/Home.aspx/API',
    apiTranslate = 'https://translate.forzacourierpack.com/api/Translate',
    sesionTime = 900000, // 15 * 60 * 1000 = 900000 milisegundos = 15 minutos
    sesionTimeExpress = 32400000, // 9 horas * 60 minutos  * 60 segundos * 1000 milisegundos = 32400000
}
